import { ROUTE_PATHS } from "../../../constants/routeConstants";

const SVG_404 = () => (
  <svg width="260" height="200" viewBox="0 0 260 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="52" cy="14" r="3" fill="#DEDEDE" />
    <circle cx="208" cy="18" r="3" fill="#DEDEDE" />
    <circle cx="14" cy="100" r="3" fill="#DEDEDE" />
    <circle cx="245" cy="95" r="3" fill="#DEDEDE" />
    <g stroke="#DEDEDE" strokeWidth="2" strokeLinecap="round">
      <line x1="18" y1="24" x2="18" y2="34" /><line x1="13" y1="29" x2="23" y2="29" />
      <line x1="235" y1="40" x2="235" y2="50" /><line x1="230" y1="45" x2="240" y2="45" />
    </g>
    <path d="M 60 160 A 80 80 0 1 1 200 160" stroke="#E5E7EB" strokeWidth="1.5" strokeDasharray="6 5" fill="none" />
    <rect x="85" y="45" width="90" height="110" rx="6" fill="white" stroke="#E5E7EB" strokeWidth="2" />
    <path d="M 153 45 L 175 45 L 175 65 Z" fill="#F3F4F6" stroke="#E5E7EB" strokeWidth="1.5" />
    <line x1="100" y1="75" x2="150" y2="75" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" />
    <line x1="100" y1="87" x2="145" y2="87" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" />
    <line x1="100" y1="99" x2="148" y2="99" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" />
    <text x="130" y="135" textAnchor="middle" fontSize="22" fontWeight="800" fill="#1F2937" fontFamily="sans-serif">404</text>
    <circle cx="168" cy="140" r="22" fill="white" stroke="#1F2937" strokeWidth="3" />
    <circle cx="168" cy="140" r="14" fill="#F9FAFB" stroke="#E5E7EB" strokeWidth="1.5" />
    <line x1="184" y1="156" x2="197" y2="169" stroke="#1F2937" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

const SVG_403 = () => (
  <svg width="260" height="200" viewBox="0 0 260 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="130" cy="80" r="52" fill="#F9FAFB" stroke="#E5E7EB" strokeWidth="2" />
    <rect x="108" y="78" width="44" height="34" rx="4" fill="white" stroke="#1F2937" strokeWidth="2.5" />
    <path d="M 114 78 L 114 68 A 16 16 0 0 1 146 68 L 146 78" stroke="#1F2937" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <circle cx="130" cy="95" r="4" fill="#1F2937" />
    <line x1="130" y1="99" x2="130" y2="106" stroke="#1F2937" strokeWidth="2.5" strokeLinecap="round" />
    <text x="130" y="158" textAnchor="middle" fontSize="20" fontWeight="800" fill="#1F2937" fontFamily="sans-serif">403</text>
  </svg>
);

const SVG_401 = () => (
  <svg width="260" height="200" viewBox="0 0 260 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="130" cy="75" r="52" fill="#F9FAFB" stroke="#E5E7EB" strokeWidth="2" />
    <circle cx="130" cy="65" r="18" fill="white" stroke="#1F2937" strokeWidth="2.5" />
    <path d="M 100 100 Q 100 82 130 82 Q 160 82 160 100 L 160 108 L 100 108 Z" fill="white" stroke="#1F2937" strokeWidth="2.5" />
    <line x1="118" y1="118" x2="142" y2="118" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" />
    <text x="130" y="158" textAnchor="middle" fontSize="20" fontWeight="800" fill="#1F2937" fontFamily="sans-serif">401</text>
  </svg>
);

const SVG_500 = () => (
  <svg width="260" height="200" viewBox="0 0 260 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="130" cy="80" r="52" fill="#FFF5F5" stroke="#FECACA" strokeWidth="2" />
    <line x1="130" y1="55" x2="130" y2="90" stroke="#EF4444" strokeWidth="4" strokeLinecap="round" />
    <circle cx="130" cy="100" r="3.5" fill="#EF4444" />
    <text x="130" y="158" textAnchor="middle" fontSize="20" fontWeight="800" fill="#1F2937" fontFamily="sans-serif">500</text>
  </svg>
);

const SVG_DEFAULT = () => (
  <svg width="260" height="200" viewBox="0 0 260 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="130" cy="80" r="52" fill="#F9FAFB" stroke="#E5E7EB" strokeWidth="2" />
    <line x1="130" y1="55" x2="130" y2="88" stroke="#9CA3AF" strokeWidth="4" strokeLinecap="round" />
    <circle cx="130" cy="100" r="3.5" fill="#9CA3AF" />
    <text x="130" y="158" textAnchor="middle" fontSize="20" fontWeight="800" fill="#1F2937" fontFamily="sans-serif">Error</text>
  </svg>
);

const SVG_MAP = {
  404: SVG_404,
  403: SVG_403,
  401: SVG_401,
  500: SVG_500,
};

const ErrorView = ({ statusCode = 0, heading = "Something went wrong", message = "An unexpected error occurred." }) => {
  const SvgIllustration = SVG_MAP[statusCode] ?? SVG_DEFAULT;

  return (
    <div className="min-h-[60vh] bg-white flex flex-col items-center justify-center px-4 py-16">
      <div className="flex flex-col items-center gap-6 max-w-md w-full text-center">
        <SvgIllustration />
        <h1 className="text-2xl font-bold text-gray-900 leading-tight">{heading}</h1>
        <p className="text-sm text-gray-500 leading-relaxed">{message}</p>
        <a
          href={ROUTE_PATHS.HOME}
          className="mt-2 inline-block bg-gray-900 hover:bg-gray-700 transition-colors text-white text-sm font-semibold px-8 py-3 rounded-full"
        >
          Go to Home
        </a>
      </div>
    </div>
  );
};

export default ErrorView;
